import styled from 'styled-components';

import { usePaddingTop } from './hooks';

export const Container = styled.div`
  min-height: 100vh;
  ${props => usePaddingTop(props.hasNavbar)};
`;
